// extracted by mini-css-extract-plugin
export default {"card":"Card_card__1aI0V","elevated":"Card_elevated__jAkI+","header":"Card_header__W50w-","body":"Card_body__UOh3+"};